import React from 'react';
import AutoMovementSettings from '../features/settings/auto-movement/AutoMovementSettings';

const AutoMovementPage: React.FC = () => {
    return <AutoMovementSettings />;
};

export default AutoMovementPage;
